import React, { useContext, useEffect, useState } from "react";
import loadingIcon from "../../images/Loading_icon.gif";
import rejectedIcon from "../../images/rejected_eph.png";
import Swal from "sweetalert2";
import { UrlContext } from "../../contexts/UrlContext";
import { UserContext } from "../../contexts/UserContext";
import expertDefaultImg from "../../images/expert-default.png";
import ExAvailabilityComment from "./ExAvailabilityComment";
import ViewApplication from "../EphProfile/ViewApplication";
import ComposeNewEmail from "../../components/EmailUI/ComposeNewEmail";

export default function RejectedRequests({
  project_id,
  project_name,
  setEmailDetails,
  setComposeEmail,
  backupData,
  setBackupData,
  projectType,
  username,
}) {
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadQuestions, setLoadQuestions] = useState(false);
  const { API_URL, URI } = useContext(UrlContext);
  const mediaLink = "https://media.licdn.com/";
  const databaseLink = "https://images.expertpowerhouse.com";
  const [showComment, setShowComment] = useState(false);
  const [isViewApplication, setIsViewApplication] = useState(false);
  const [currentExpertID, setCurrentExpertID] = useState(null);

  const [expertName, setExpertName] = useState("");
  const [acceptTemplate, setAcceptTemplate] = useState([]);
  const [requestSelected, setRequestSelected] = useState(null);
  const [acceptRequest, setAcceptRequest] = useState(false);

  // Fetch consultant requests
  useEffect(() => {
    setLoading(true);
    const url = `${API_URL}rejected-from-project/${project_id}`;
    fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setLoading(false);
        setRequests(data.data);
        setLoadQuestions(!loadQuestions);
        if (data.status == "error") {
          Swal.fire({
            title: `${data.message}`,
            icon: "error",
            showConfirmButton: true,
          });
        }
      })
      .catch((err) => {
        Swal.fire({
          title: "Something Went Wrong!",
          icon: "error",
          timer: 2000,
        });
      });
  }, []);

  const generateAcceptTemplates = async (expertName, userName, projectName) => {
    const firstName = typeof expertName === "string" && expertName.trim().length > 0
      ? expertName.trim().split(" ")[0]
      : expertName;

    return [
      {
        lang: "en",
        label: "English",
        name: "Application Acknowledgment",
        subject: `expertpowerhouse | Your application to "${projectName}" has been accepted`,
        value: `
          <div>Dear ${firstName},</div>
          <div><br></div>
          <div>Many thanks for your application for the project opportunity "${projectName}" via our platform. We would be very happy to present your profile to our client. Should we have any questions, we will reach out to you shortly. Otherwise, we will let you know should the client be interested in your profile and arrange all further steps.</div>
          <div><br></div>
          <div>Best regards,</div>
          <div>${userName}</div>
        `,
      },
      {
        lang: "de",
        label: "German",
        name: "Bewerbungsbestätigung",
        subject: `expertpowerhouse | Die Bewerbung für "${projectName}" wurde angenommen`,
        value: `
          <div>Hallo ${firstName},</div>
          <div><br></div>
          <div>vielen Dank für deine Bewerbung für das Projekt "${projectName}" über unsere Plattform. Wir würden dein Profil sehr gerne unserem Kunden vorstellen. Sollten wir Rückfragen haben, werden wir uns zeitnah melden. Andernfalls informieren wir dich, sobald der Kunde Interesse an deinem Profil zeigt, und koordinieren alle weiteren Schritte.</div>
          <div><br></div>
          <div>Viele Grüße,</div>
          <div>${userName}</div>
        `,
      },
    ];
  };

  const openAcceptEmail = async (data) => {
    setRequestSelected(data);
    const accept = await generateAcceptTemplates(
      data?.name,
      username,
      project_name
    );
    setAcceptTemplate(accept);
    setAcceptRequest(true);
  };

  const addToProjectHandle = (_payload = {}) => {
    const tokenObj = localStorage.getItem("eph-token");
    const token = JSON.parse(tokenObj).value;
    const accessToken = localStorage.getItem("accesstoken");
    const url = `${API_URL}add-from-request`;
    const confirmationMail = "";
    const modifiedSubject = "";

    fetch(url, {
      method: "POST",
      headers: {
        "x-access-token": token,
        "Content-Type": "application/json",
        Authorization: accessToken,
      },
      body: JSON.stringify({
        expertID: requestSelected.ID,
        email: requestSelected.email,
        projectID: project_id,
        requestID: requestSelected.request_id,
        summary: `${requestSelected.firstQuestion}\n\n${requestSelected.secondQuestion}`,
        subject: modifiedSubject,
        confirmationMail,
      }),
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.status === "success") {
          Swal.fire({
            title: "Success!",
            text: "Consultat added to this project",
            icon: "success",
            confirmButtonText: "OK",
          });
          setRequests(
            requests.filter(
              (req) => req.request_id != requestSelected.request_id
            )
          );
          window.location.reload();
        } else if (data.status === "error") {
          Swal.fire({
            title: "Error!",
            text: `${data.msg}`,
            icon: "error",
          });
        } else {
          Swal.fire({
            title: "Error!",
            text: "Something went wrong!",
            icon: "error",
          });
        }
      })
      .catch((err) => {
        Swal.fire({
          title: "Error!",
          text: "Something went wrong!",
          icon: "error",
        });
      });
  };

  return (
    <>
      <div className="project-details-request-container mb-6">
        {requests.length > 0 && (
          <div>
            {requests.map((data) => (
              <div className="mt-3">
                <div
                  className="prjdetails-table-row"
                  style={{ margin: "0", opacity: 0.6 }}
                >
                  <div className="prjdetails-row-top">
                    <div className="row-left-top-div">
                      <div className="con-image-div">
                        <a
                          href={`/app/ExpertDetails/${data?.ID}`}
                          className="prjdetails-eph-profile"
                          target="_blank"
                          rel="noreferrer"
                        >
                          <img
                            className={`prjdetails-con-img `}
                            src={
                              data?.profilePicture?.slice(0, 24) == mediaLink
                                ? data?.profilePicture
                                : `${databaseLink}${data?.profilePicture}`
                            }
                            alt=""
                            onError={(e) => {
                              e.target.onerror = null;
                              e.target.src = expertDefaultImg;
                            }}
                          />
                        </a>
                        <div className="name-con-expert-div">
                          <a
                            className="prjdetails-con-name"
                            href={data?.link}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {data?.name}
                          </a>
                          <div className="position-relative">
                            <select
                              className="prjdetails-select-con no-select"
                              value={data?.cons_exp}
                              style={{ marginRight: "20px" }}
                            >
                              <option value={data?.cons_exp}>
                                {data?.cons_exp}
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="left-bottom-phone position-relative">
                        <i
                          className="fa-regular fa-envelope"
                          style={{ marginRight: "1px", fontSize: "16px" }}
                        />
                        <input placeholder="Email" value={data?.email} />
                      </div>
                      <div className="left-bottom-phone position-relative">
                        <i
                          className="fa-solid fa-phone"
                          style={{ marginRight: "2px" }}
                        />
                        <input
                          placeholder="Phone number"
                          value={data?.phone_n}
                        />
                      </div>

                      <div className="left-bottom-hourly position-relative flex flex-row items-center gap-2">
                        <i
                          className="fa-solid fa-money-bill-1"
                          title="Hourly rate"
                        />
                        <p className="text-[#365561]">{data?.hourly_rate}</p>
                        <p className="text-xs text-[#365561]">
                          {projectType === "exp" &&
                            data?.expectedRate &&
                            `Expects: ${data?.expectedRate}`}
                        </p>
                      </div>
                      <div className="left-bottom-daily position-relative flex flex-row items-center gap-2">
                        <i
                          className="fa-solid fa-money-bill"
                          title="Daily rate"
                        />
                        <p className="text-[#365561]">{data?.daily_rate}</p>
                        <p className="text-xs text-gray-400">
                          {projectType !== "exp" &&
                            data?.expectedRate &&
                            `Expects: ${data?.expectedRate}`}
                        </p>
                      </div>
                    </div>
                    <div style={{ display: "inline-flex" }}>
                      <div className="prjdetails-panel prjdetails-third-panel">
                        <div className="prjdetails-panel-body pn">
                          <table className="table prjdetails-second-section mbn tc-icon-1 tc-med-2 tc-bold-last">
                            <tbody>
                              <tr>
                                <td className="position-relative">
                                  <textarea
                                    readOnly
                                    placeholder="Summary"
                                    title="Summary"
                                    value={data?.summ || ""}
                                    className="w-full p-2 border rounded text-sm"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td className="position-relative">
                                  <textarea
                                    readOnly
                                    placeholder="Experience"
                                    title="Experience"
                                    value={data?.experience || ""}
                                    className="w-full p-2 border rounded text-sm"
                                  />
                                </td>
                              </tr>
                              <tr>
                                <td className="position-relative">
                                  <div
                                    className="w-[320px] max-h-[60px] overflow-y-auto p-2 border rounded text-sm text-[#365561] leading-relaxed [&_ul]:list-disc [&_ul]:pl-6 [&_h3]:text-lg [&_h3]:font-semibold"
                                    dangerouslySetInnerHTML={{
                                      __html: `${
                                        data?.firstQuestion || ""
                                      }<br/>${data?.secondQuestion || ""}`,
                                    }}
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>

                    <div className="prjdetails-panel prjdetails-action-btn">
                      <div className="prjdetails-btns-div position-relative"></div>
                    </div>
                    <div className="prjdetails-panel prjdetails-action-btn">
                      <div className="prjdetails-btns-div position-relative">
                        <img
                          src={rejectedIcon}
                          alt="Rejected"
                          className="w-60 h-40"
                        />
                      </div>
                    </div>
                    <div className="prjdetails-panel prjdetails-action-btn">
                      <div className="prjdetails-btns-div position-relative"></div>
                    </div>

                    <div className="prjdetails-panel prjdetails-action-btn flex flex-col justify-center items-center">
                      <div className="prjdetails-btns-div position-relative">
                        <button
                          className="btn addToPjButton"
                          onClick={() => {
                            setCurrentExpertID(data.ID);
                            setIsViewApplication(true);
                          }}
                        >
                          <i class="fa-solid fa-eye mr-2"></i>
                          View
                        </button>

                        <button
                          className="btn addToPjButton"
                          onClick={() => {
                            openAcceptEmail(data);
                          }}
                        >
                          <i className="fa-solid fa-user-plus mr-2" />
                          Accept
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="prjdetails-row-bottom">
                    <div style={{ float: "left", marginLeft: "11px" }}>
                      {showComment && (
                        <ExAvailabilityComment
                          comment={data?.Available_comment}
                          expert_id={data?.ID}
                          backupData={backupData}
                          setBackupData={setBackupData}
                          setShowComment={setShowComment}
                        />
                      )}
                      <div className="topCon-available-date">
                        <i
                          className="calender-icon fa-regular fa-calendar-days"
                          style={{ marginRight: "11px" }}
                        ></i>
                        <label>Availability</label>
                        <i
                          className={
                            data?.Available_comment
                              ? "comment-icon fa-regular fa-comment-dots"
                              : "comment-icon comment-empty fa-regular fa-comment-dots"
                          }
                          onClick={() => setShowComment(!showComment)}
                          title="Click to see comment"
                          style={{ left: "98px" }}
                        ></i>
                        <input
                          type="date"
                          style={{ height: "26px" }}
                          value={new Date(data?.Available_from)
                            .toISOString()
                            .slice(0, 10)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* View consultant request */}
      {isViewApplication && currentExpertID && (
        <ViewApplication
          projectID={project_id}
          expertID={currentExpertID}
          callingFrom={"project"}
          onClose={() => {
            setIsViewApplication(false);
            setCurrentExpertID(null);
          }}
        />
      )}

      {acceptRequest && (
        <ComposeNewEmail
          onClose={() => setAcceptRequest(false)}
          defaultTo={[requestSelected?.email]}
          defaultTemplates={acceptTemplate}
          logFunction={addToProjectHandle}
        />
      )}
    </>
  );
}
